import Details from '@admin/components/details'
import Button from '@admin/components/button'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

const Overview = ({ payout }) => {

  const affiliate = {
    label: payout.affiliate.team.title,
    className: 'link',
    route: `/admin/truevail/admin/affiliates/${payout.affiliate.id}`
  }

  const details = {
    audits: `maha_payouts/${payout.id}`,
    comments: `maha_payouts/${payout.id}`,
    sections: [
      {
        title: 't(Payout)',
        items: [
          { label: 't(Affiliate)', content: <Button { ...affiliate } /> },
          { label: 't(Date)', content: payout.date, format: 'date' },
          { label: 't(Payments)', content: payout.payments_count },
          { label: 't(Commision Rate)', content: payout.rate, format: 'rate' },
          { label: 't(Commision)', content: payout.total, format: 'currency' },
          ...(payout.bank_name ? [
            { label: 't(Bank Account)', content: `${payout.bank_name} - ${payout.bank_last_four}` }
          ] : []),
          ...(payout.status === 'failed' ? [
            { label: 't(Error)', content: <span className="alert">{ payout.error }</span> }
          ] : [])
        ]
      }
    ]
  }

  if(payout.status === 'pending') {
    details.alert = { color: 'teal', message: 't(This payout is pending)' }
  } else if(payout.status === 'paid') {
    details.alert = { color: 'green', message: 't(This payout has been paid)' }
  } else if(payout.status === 'failed') {
    details.alert = { color: 'red', message: 't(This payout failed)' }
  } else if(payout.status === 'processing') {
    details.alert = { color: 'yellow', message: 't(This payout is being processed)' }
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  payout: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview payout={ props.payout } />,
  tasks: {
    items: [
      {
        label: 't(Issue Payout)',
        svg: 'hand_coins',
        show: ['pending','failed'].includes(props.payout.status),
        request: {
          endpoint: `/api/admin/truevail/admin/payouts/${props.payout.id}/issue`,
          method: 'PATCH'
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
